/**
 * Stable per-user calendar colors so each staff member's events are easy to spot.
 * Prefer preferences.calendarColor when present; otherwise hash user id into a palette.
 */

const USER_PALETTE = [
  '#1565C0', // blue
  '#2E7D32', // green
  '#C62828', // red
  '#6A1B9A', // purple
  '#EF6C00', // orange
  '#00838F', // teal
  '#AD1457', // pink
  '#4527A0', // deep purple
  '#558B2F', // light green
  '#0277BD', // light blue
  '#F9A825', // amber
  '#37474F', // blue grey
];

function hashId(id: string): number {
  let h = 0;
  for (let i = 0; i < id.length; i += 1) {
    h = (h * 31 + id.charCodeAt(i)) >>> 0;
  }
  return h;
}

export function getCalendarUserColor(
  creator: { id?: string; calendarColor?: string | null } | null | undefined,
  fallback = '#757575',
): string {
  if (creator?.calendarColor && /^#[0-9A-Fa-f]{6}$/.test(creator.calendarColor)) {
    return creator.calendarColor;
  }
  if (creator?.id) {
    return USER_PALETTE[hashId(creator.id) % USER_PALETTE.length];
  }
  return fallback;
}

/** Event-type accent (legacy); use when no creator is available. */
export function getEventTypeFallbackColor(eventType: string, themeColors: Record<string, string>): string {
  return themeColors[eventType] || themeColors.other || '#9e9e9e';
}
